import { RENDERCARDTYPE } from "@/constants/renderCardType";
import useAppStore from "@/context/store";
import { useCallback, useRef, useState } from "react";
import BoardCard from "../BoardCard";
import HBList from "../HBList";
import RecommendCard from "../RecommendCard";
import SimilarCard from "../SimilarCard";

/**
 * 画板列表
 * @param {{
 *   hideButton?: boolean;
 *   hideUser?: boolean;
 *   hideTime?: boolean;
 *   dataSource: IBoardInfo[];
 *   type?: string;
 *   onFollow?: (board: IBoardInfo) => void;
 *   children?: React.ReactNode;
 *   customColumn?: number;
 *   customColumnSize?: number;
 * } & Partial<Parameters<typeof HBList>[0]>} param0
 * @returns
 */
export default function BoardList({
  hideButton,
  hideUser,
  hideTime,
  dataSource,
  type,
  onFollow,
  children,
  customColumn,
  customColumnSize,
  showLikeBtn,
  ...props
}) {
  const [deleteMap, setDeleteMap] = useState({});
  const column = useAppStore(({ column }) => column);
  const columnSize = useAppStore(({ columnSize }) => columnSize);
  const masonryRef = useRef(null);
  const filter = useCallback(
    (dataSource) => {
      return dataSource.filter((record) => !deleteMap[record.board_id]);
    },
    [deleteMap]
  );

  // 获取AB测试的结果
  // const { value: boardCardType } = useABTest("board_card", "feed-new");

  // 卡片类型变化后，重新布局瀑布流
  // useUpdateEffect(() => {
  //   masonryRef.current?.relayout();
  // }, [boardCardType]);

  const onDelete = useCallback((boardId) => {
    setDeleteMap((deleteMap) => {
      return {
        ...deleteMap,
        [boardId]: true,
      };
    });
  }, []);

  const render = useCallback(
    (record, index) => {
      if (record.type === RENDERCARDTYPE.recommend) {
        return (
          <RecommendCard
            style={{
              marginBottom: "16px",
              height: 454,
            }}
            key={record.board_id}
            record={record}
            onDelete={onDelete}
            columnSize={customColumnSize || columnSize}
          />
        );
      } else if (record.type === RENDERCARDTYPE.similar) {
        return (
          <SimilarCard
            key={record.pinId}
            width={customColumnSize || columnSize}
            record={record}
            style={{
              marginBottom: "15px",
            }}
            height={((customColumnSize || columnSize) * 0.67 + 73) * 2}
            pins={record?.data?.pins}
            href={`/pins/${record.pinId}/similar/materials`}
            isSimilar
            title="素材专区"
            target="_blank"
            subTitle="相似商用素材"
            data-gd-click="button_click"
            data-button-name="更多相似商用素材"
            data-gd-expose="resource_loc_expose"
            data-resource-type="图片"
            data-resource-id="0"
            data-resource-title="相似商用素材"
            data-content-source="相似商用素材_同在画板"
          ></SimilarCard>
        );
      } else if (record.type === RENDERCARDTYPE.artRecommend) {
        return (
          <SimilarCard
            key={record.pinId}
            width={customColumnSize || columnSize}
            record={record}
            style={{
              marginBottom: "15px",
            }}
            height={((customColumnSize || columnSize) * 0.67 + 73) * 2}
            pins={record?.data?.pins}
            href={`https://www.gaoding.art/search?q=${record.data?.search_word}`}
            isAi
            title="AI 创意专区"
            subTitle="更多 AI 创意作品"
            data-gd-click="button_click"
            data-button-name="更多AI内容推荐"
            target="_blank"
            data-gd-expose="resource_loc_expose"
            data-resource-type="图片"
            data-resource-id="0"
            data-resource-title="更多AI内容推荐"
            data-content-source="AI内容推荐_同在画板/为你推荐"
          ></SimilarCard>
        );
      }

      return (
        <BoardCard
          key={record.board_id || index}
          hideButton={hideButton}
          hideUser={hideUser}
          hideTime={hideTime}
          record={record}
          onDelete={onDelete}
          onFollow={onFollow}
          type={type}
          boardType="new"
          showLikeBtn={showLikeBtn}
        />
      );
    },
    [
      columnSize,
      customColumnSize,
      hideButton,
      hideTime,
      hideUser,
      onDelete,
      onFollow,
      type,
      showLikeBtn,
    ]
  );

  return (
    <HBList
      filter={filter}
      masonryRef={masonryRef}
      {...props}
      loginGuide={true}
      uniqueKey="board_id"
      render={render}
      dataSource={dataSource}
      masonryOptions={{
        columnNum: customColumn || column,
        brickId: "board_id",
        columnSize: customColumnSize || columnSize,
      }}
    >
      {children}
    </HBList>
  );
}
